import buildLoyaltySelectedUpgradeKey from 'loyalty/lib/benefits/buildLoyaltySelectedUpgradeKey'

function getSelectedLoyaltyTargetUpgradePackage(
  selectedPackageOption: App.OfferPackageOptionView,
  availablePackageOptions: Array<App.OfferPackageOptionView>,
  loyaltyTargetRoomUpgradesSelected: App.LoyaltyTargetStayUpgradesSelected | undefined,
): { packageOptionView: App.OfferPackageOptionView; upgradeType: App.LoyaltyStayUpgradeType } | undefined {
  const selectedUpgradeKey = buildLoyaltySelectedUpgradeKey(selectedPackageOption.package)
  const selectedPackageTargetUpgradeType = selectedUpgradeKey ? loyaltyTargetRoomUpgradesSelected?.[selectedUpgradeKey] : undefined
  if (!selectedPackageTargetUpgradeType) return

  const targetUpgradeLePackage = selectedPackageOption.package.loyalty.upgradeTargets?.[selectedPackageTargetUpgradeType]
  if (!targetUpgradeLePackage) return
  const targetUpgradePackageOptionView = availablePackageOptions.find(option => option.package.uniqueKey === targetUpgradeLePackage.uniqueKey)

  if (
    !targetUpgradePackageOptionView ||
    !targetUpgradePackageOptionView?.capacityValid ||
    !targetUpgradePackageOptionView?.hotelAvailable
  ) return

  return {
    packageOptionView: targetUpgradePackageOptionView,
    upgradeType: selectedPackageTargetUpgradeType,
  }
}

export default getSelectedLoyaltyTargetUpgradePackage
